export const BTN_TYPE_ADD = 'add';
export const BTN_TYPE_REMOVE = 'remove';
